import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

// Same header convention as the rest of the app (no server session; role/class travel in headers).
export const authHeaders = (user) => ({
  'x-user-role': user?.role || '',
  'x-user-name': encodeURIComponent(user?.name || user?.email || ''),
  'x-user-class': user?.class || user?.assignedClass || ''
});

export const biGet = (user, path, params = {}) =>
  axios.get(`${API_BASE_URL}${path}`, { headers: authHeaders(user), params }).then((r) => r.data);

export const biPost = (user, path, body) =>
  axios.post(`${API_BASE_URL}${path}`, body, { headers: authHeaders(user) }).then((r) => r.data);

export const biPatch = (user, path, body) =>
  axios.patch(`${API_BASE_URL}${path}`, body, { headers: authHeaders(user) }).then((r) => r.data);

export const today = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const errText = (e) => e?.response?.data?.error || e?.message || 'Something went wrong';

// Brand palette (Corporate Dark Theme)
export const C = {
  cyan: '#38bdf8',    // Sky-400
  indigo: '#818cf8',  // Indigo-400
  emerald: '#34d399', // Emerald-400
  amber: '#fbbf24',   // Amber-400
  rose: '#fb7185',    // Rose-400
  slate: '#94a3b8',   // Slate-400
  grid: '#334155'     // Slate-700
};

export const tooltipStyle = {
  contentStyle: { 
    backgroundColor: '#0f172a', 
    borderColor: '#334155', 
    borderRadius: '0.75rem', 
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5)', 
    color: '#f8fafc', 
    fontSize: '13px', 
    fontWeight: '600',
    padding: '10px 15px'
  },
  itemStyle: { color: '#e2e8f0', fontSize: '12px' },
  labelStyle: { color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' },
  cursor: { fill: 'rgba(51, 65, 85, 0.4)' }
};
